import dayjs from "dayjs";

export const getQuickTimeRange = (type = "string", timeRange) => {
  let timeRangeAsStr = "";
  let timeRangeAsObj = {};

  const setStartEndTime = (today = new Date()) => {
    const areDatesSame = (d1, d2) => {
      const res =
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
          ? true
          : false;
      return res;
    };

    let startDateTime = new Date(today);
    let endDateTime = new Date(today);

    if (timeRange === "today") {
      startDateTime.setDate(today.getDate());
      startDateTime.setHours(0, 0, 0, 0);
      endDateTime = new Date(endDateTime);
    } else if (timeRange === "yesterday") {
      startDateTime.setDate(today.getDate() - 1);
      startDateTime.setHours(0, 0, 0, 0);
      endDateTime.setDate(today.getDate() - 1);
      endDateTime.setHours(23, 59, 59, 999);
    } else if (timeRange === "thisWeek") {
      const dayOfWeek = today.getDay();
      startDateTime.setDate(today.getDate() - dayOfWeek);
      startDateTime.setHours(0, 0, 0, 0);
      if (areDatesSame(today, new Date())) {
        endDateTime = new Date(today);
      } else {
        endDateTime.setDate(today.getDate() + (dayOfWeek + 6));
        endDateTime.setHours(23, 59, 59, 999);
      }
    } else if (timeRange === "lastWeek") {
      const dayOfWeek = today.getDay();
      startDateTime.setDate(today.getDate() - (dayOfWeek + 7));
      startDateTime.setHours(0, 0, 0, 0);
      endDateTime.setDate(today.getDate() - (dayOfWeek + 1));
      endDateTime.setHours(23, 59, 59, 999);
    } else if (timeRange === "thisMonth") {
      startDateTime = new Date(today.getFullYear(), today.getMonth(), 1);
      startDateTime.setHours(0, 0, 0, 0);
      if (areDatesSame(today, new Date())) {
        endDateTime = new Date(endDateTime);
      } else {
        endDateTime = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        endDateTime.setHours(23, 59, 59, 999);
      }
    } else if (timeRange === "lastMonth") {
      const thisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastMonth = new Date(thisMonth);
      lastMonth.setDate(0);
      startDateTime = new Date(lastMonth.getFullYear(), lastMonth.getMonth());
      startDateTime.setHours(0, 0, 0, 0);
      endDateTime = new Date(lastMonth);
      endDateTime.setHours(23, 59, 59, 999);
    }
    timeRangeAsStr = `${startDateTime
      .toLocaleString()
      .replace(/\//g, "-")} to ${endDateTime
      .toLocaleString()
      .replace(/\//g, "-")}`;
    timeRangeAsObj = {
      startTime: startDateTime.getTime(),
      endTime: endDateTime.getTime(),
    };
  };

  setStartEndTime();
  let retTimeRange;
  if (type === "string") {
    retTimeRange = timeRangeAsStr;
  } else if (type === "obj") {
    retTimeRange = timeRangeAsObj;
  }
  return retTimeRange;
};

export const getPresetDateRange = (type = "array", dateRange) => {
  let dateRangeAsObj = {};
  let dateRangeAsArr = [];

  const setStartEndDate = (today = new Date()) => {
    let startDate, endDate;

    switch (dateRange) {
      case "thisYear":
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "lastYear":
        startDate = new Date(today.getFullYear() - 1, 0, 1);
        endDate = new Date(today.getFullYear() - 1, 11, 31);
        break;
      case "thisMonth":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "lastMonth":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case "last3months":
        startDate = new Date(today.getFullYear(), today.getMonth() - 3, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case "last6months":
        startDate = new Date(today.getFullYear(), today.getMonth() - 6, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case "allTime":
        startDate = new Date(today.getFullYear() - 1, 0, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;

      default:
        break;
    }
    dateRangeAsObj = { startDate, endDate };
    dateRangeAsArr = [dayjs(startDate), dayjs(endDate)];
  };

  setStartEndDate();
  let retDateRange;
  if (type === "obj") {
    retDateRange = dateRangeAsObj;
  } else if (type === "array") {
    retDateRange = dateRangeAsArr;
  }
  return retDateRange;
};
